import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Slider from './../Elements/Slider';
import Specialization3 from './../Elements/Specialization3';
import About2 from './../Elements/About2';

import OurValue from './../Elements/OurValue';
import OurMission from './../Elements/OurMission';
import OurServices from './../Elements/OurServices';
import OurServices3 from './../Elements/OurServices3';

import OurProject2 from './../Elements/OurProject2';
import Blogs from './../Elements/Blogs';
import Testimonials from './../Elements/Testimonials';

class Home extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Slider />
                  
                    <About2 />       
                  
                    {/* <OurValue /> */}
                    <OurMission />
                    <OurServices3 />
                 
                    <OurProject2 />
                    {/* <Blogs />
                    <Testimonials /> */}
                </div>
                <Footer />
            </>
        );
    };
};

export default Home;